import { SvgIcon, SvgIconProps } from "@mui/material";

export const LinkV2Icon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="m17.445 12.778 2.333-2.333a4.401 4.401 0 0 0 0-6.223v0a4.401 4.401 0 0 0-6.223 0l-2.333 2.333M8.89 15.11l6.22-6.22M6.555 11.222l-2.333 2.333a4.401 4.401 0 0 0 0 6.223v0a4.401 4.401 0 0 0 6.223 0l2.333-2.333"
      />
    </svg>
  </SvgIcon>
);
